import styled from 'styled-components';

export const PositionHistoryPinPopoverContainer = styled.div`
  font-family: ${({ theme }): string => theme.fonts.p1News};
  width: max-content;
`;

export const PositionHistoryPinPopoverTitle = styled.p`
  width: 200px;
  margin: 0;
  margin-bottom: 12px;
  color: ${({ theme }): string => theme.kcc.colors.BLACK};
  opacity: 0.8;
  word-break: break-word;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: ${({ theme }): number => theme.kcc.typography.FONT_SIZE.SM}px;
  font-weight: ${({ theme }): number => theme.kcc.typography.FONT_WEIGHT.BOLD};
`;

export const PositionHistoryPinPopoverContent = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 4px;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
`;

export const PositionHistoryPinPopoverText = styled.p<{ $hasExitedAt: boolean }>`
  width: max-content;
  margin: 0;
  color: ${({ theme, $hasExitedAt }): string =>
    $hasExitedAt ? theme.kcc.colors.TEXT_SECONDARY : theme.kcc.colors.TEXT};
  word-break: break-word;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  font-size: ${({ theme }): number => theme.kcc.typography.FONT_SIZE.SM}px;
  font-weight: ${({ theme }): number => theme.kcc.typography.FONT_WEIGHT.REGULAR};
`;
